import React from 'react';
import SISIntegration from '@/components/admin/SISIntegration';

export default function SISConfiguration() {
  return <SISIntegration />;
}